import { useEffect } from 'react';

export function useProcessingPoll(
  active: boolean,
  poll: () => void,
  intervalMs: number,
) {
  useEffect(() => {
    if (!active) return;
    const timer = setInterval(poll, intervalMs);
    return () => clearInterval(timer);
  }, [active, poll, intervalMs]);
}
